import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=9899a876&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"
import style0 from "./Steps.vue?vue&type=style&index=0&id=9899a876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9899a876",
  null
  
)

export default component.exports